import type { App } from "vue"
import { z } from "zod"

export function loadZod(app: App) {
  app.config.globalProperties.$zod = z
  return app
}

export default z
export { z }
